import { createStore, combineReducers } from "redux";
import { reducer as form } from "redux-form";

const store = createStore(combineReducers({
  form
}));

export default store;
